import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OverlayPanel } from 'primeng/overlaypanel';

import { ContadorService } from '../../services/contador/contador.service';
import { DespesaAcessoriaService } from '../../services/contador/despesa-acessoria.service';
import { PermissaoService } from '../../services/permissao/permissao.service';
import { SolicitacaoContratoRecebidaDTO } from '../../models/contador/contador.model';
import { DespesaAcessoriaPendenteDTO } from '../../models/contador/despesa-acessoria.model';

/**
 * Sino de notificacoes (header). Agrupa as pendencias do cliente autenticado:
 * - Solicitacoes de contrato de contador PENDENTES.
 * - Despesas acessorias do contador PENDENTES de aprovacao.
 *
 * O dropdown lista as pendencias com um resumo; ao clicar em qualquer item
 * (contrato ou despesa), fecha o sino e navega para a tela de notificacoes do
 * contador (`/contador/notificacoes?origem=sino`), onde o cliente decide cada
 * pendencia. A `origem=sino` faz a tela de destino exibir o botao "Voltar".
 */
@Component({
  selector: 'app-notificacoes-contrato',
  templateUrl: './notificacoes-contrato.component.html',
  styleUrls: ['./notificacoes-contrato.component.scss'],
})
export class NotificacoesContratoComponent implements OnInit {
  solicitacoes: SolicitacaoContratoRecebidaDTO[] = [];
  carregando = false;

  // Despesas acessorias pendentes de aprovacao pelo cliente.
  despesas: DespesaAcessoriaPendenteDTO[] = [];

  constructor(
    private contadorService: ContadorService,
    private despesaService: DespesaAcessoriaService,
    private permissaoService: PermissaoService,
    private router: Router,
  ) {}

  /**
   * Exibe o sino apenas para quem tem o privilegio "Gestao do Contador"
   * (espelha o gating do mobile e evita vazar a contagem de pendencias no
   * header de quem nao deve ve-la).
   */
  get podeVer(): boolean {
    return this.permissaoService.temPermissao('gestaoContador');
  }

  ngOnInit(): void {
    // Sem o privilegio nao carrega nada (o sino fica oculto no template).
    if (!this.podeVer) {
      return;
    }
    this.carregar();
  }

  /** Total de pendencias (contratos + despesas) para o badge do sino. */
  get totalPendencias(): number {
    return this.solicitacoes.length + this.despesas.length;
  }

  /** Recarrega as pendencias (silencioso — falha nao incomoda o usuario). */
  carregar(): void {
    this.carregando = true;
    this.contadorService.listarSolicitacoesRecebidas().subscribe({
      next: (res) => {
        this.solicitacoes = res || [];
        this.carregando = false;
      },
      error: () => {
        this.solicitacoes = [];
        this.carregando = false;
      },
    });

    this.despesaService.listarPendentes().subscribe({
      next: (res) => {
        this.despesas = res || [];
      },
      error: () => {
        this.despesas = [];
      },
    });
  }

  /**
   * Clique em uma notificacao do contador (contrato ou despesa): fecha o sino e
   * navega para a tela de notificacoes do contador, marcando a origem `sino`
   * (para a tela de destino exibir o botao "Voltar").
   */
  abrirNotificacoes(op?: OverlayPanel): void {
    op?.hide();
    this.router.navigate(['/contador/notificacoes'], { queryParams: { origem: 'sino' } });
  }
}
